import CommonError from '../Common/CommonError'

const Error401Container = () => {
  return (
    <CommonError color="primary" src="2"/>
  )
}

export default Error401Container